import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const ChecklistHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on the top
    <br/>
    <img src={makeToolTipUrl('checklist/1.CMS-checklist-headline.png')} width="100%"/>
  </div>
);

export const ChecklistIntroCopyToolTip = (props) => (
  <div>
    Copy that introduces the break.
    <br/>
    <img src={makeToolTipUrl('checklist/2.CMS-checklist-intro.png')} width="100%"/>
  </div>
);

export const ChecklistHeaderImageToolTip = (props) => (
  <div>
    Image to introduce the list.
    <br/>
    <img src={makeToolTipUrl('checklist/3.CMS-checklist-header-img.png')} width="100%"/>
  </div>
);

export const ChecklistListItemTitleToolTip = (props) => (
  <div>
    Brief copy or title describing the list item.
    <br/>
    <img src={makeToolTipUrl('checklist/4.CMS-checklist-list-item-title.png')} width="100%"/>
  </div>
);

export const ChecklistListItemDescriptionToolTip = (props) => (
  <div>
    Main copy for this list item
    <br/>
    <img src={makeToolTipUrl('checklist/5.CMS-checklist-list-item-description.png')} width="100%"/>
  </div>
);

export const ChecklistChooseImageWidthToolTip = (props) => (
  <div>
    If Full is selected, the image will be the full width of the break. If Half is selected, the image will appear half the size of the break. If None is selected, copy will always be the full width.
    <br/>
    <img src={makeToolTipUrl('checklist/6.CMS-checklist-choose-img-width.png')} width="100%"/>
  </div>
);

export const ChecklistChooseResultTypeToolTip = (props) => (
  <div>
    If Full is selected, the image will be the full width of the break. If Half is selected, the image will appear half the size of the break. If None is selected, copy will always be the full width.
    <br/>
    <img src={makeToolTipUrl('checklist/6.CMS-checklist-choose-img-width.png')} width="100%"/>
  </div>
);
export const ChecklistListItemImageToolTip = (props) => (
  <div>
    Image for this list item.
    <br/>
    <img src={makeToolTipUrl('checklist/7.CMS-checklist-list-item-img.png')} width="100%"/>
  </div>
);

export const ChecklistResultTitleToolTip = (props) => (
  <div>
    Copy related to the content and items selected in the checklist.
    <br/>
    <img src={makeToolTipUrl('checklist/8.CMS-checklist-results-title.png')} width="100%"/>
  </div>
);

export const ChecklistResultDescriptionToolTip = (props) => (
  <div>
    Field for further description on the checklist selections.
    <br/>
    <img src={makeToolTipUrl('checklist/9.CMS-checklist-results-description.png')} width="100%"/>
  </div>
);

export const ChecklistResultImageToolTip = (props) => (
  <div>
    Image that relates to the result.
    <br/>
    <img src={makeToolTipUrl('checklist/10.CMS-checklist-results-img.png')} width="100%"/>
  </div>
);

export const ChecklistMinItemsToolTip = (props) => (
  <div>
    The minimum amount of items checked to attain this result.
  </div>
);

export const ChecklistMaxItemsToolTip = (props) => (
  <div>
    The maximum amount of items checked to attain this result.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/checklist-tool-tips.jsx